export default __webpack_public_path__ + "static/AppMoneyWalkie15-ad10f7055e06a7e3b22ddb0fb51afbc5.png";